<template>
    <div class="skill_div">
        <SkillsSubmit></SkillsSubmit>
    </div>
</template>
<script type="text/javascript">
import SkillsSubmit from '@/components/skill_page/skill_submit.vue'

export default {
    components: {
        SkillsSubmit
    },
}



</script>
<style type="text/css">

</style>

